export default function ButtonLoader() {
  return (
    <button className="btn btn--disabled btn--icon">
      <span class="fa--sm fa--primary">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    </button>
  );
}
